import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-bottom" }

import '@/assets/styles/footer.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'FooterImpressum',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"footer-container\"><div class=\"footer-block\"><h3>KFZ Musterwerkstatt</h3><p> Inhaber: Max Mustermann<br> Musterstraße 12<br> 12345 Musterstadt </p><p> Tel: <a href=\"tel:+491234567890\">01234 567890</a><br> E-Mail: <a href=\"mailto:info@musterwerkstatt.example\"> info@musterwerkstatt.example </a></p></div><div class=\"footer-block\"><h3>Rechtliches</h3><p> Berufsbezeichnung: Kraftfahrzeugtechnikermeister<br> Verliehen in Deutschland<br> Zuständige Kammer: Handwerkskammer Musterstadt </p><p> Umsatzsteuer-ID: DE123456789 (Beispielangabe) </p></div><div class=\"footer-block\"><h3>Links</h3><ul><li><a href=\"/impressum\">Impressum</a></li><li><a href=\"/datenschutz\">Datenschutz</a></li></ul></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, " © " + _toDisplayString(new Date().getFullYear()) + " KFZ Musterwerkstatt", 1),
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "creator" }, "Fiktive Demo-Website · Alle Angaben sind Beispiele", -1))
    ])
  ]))
}
}

})